export default __webpack_public_path__ + "static/media/checkBlack.24ecf688.svg";